export const dataTypes = {
  DATE: 1,
};

export const editableFields = {
  ARRIVED: 'arrived_at',
  LOADING_START: 'loading_started_at',
  LOADING_END: 'loading_ended_at',
  DISPATCHED: 'dispatched_at',
};

export const pickupFormData = [
  {
    field: editableFields.ARRIVED,
    label: 'INDENT_TRUCK_IN_DATE_TIME',
    data_type: dataTypes.DATE,
    shipper_only: false,
  },
  {
    field: editableFields.LOADING_START,
    label: 'MDM_LOADING_START_TIME',
    data_type: dataTypes.DATE,
    shipper_only: true,
    validation: 'isLoadingAtSourceEnabled',
  },
  {
    field: editableFields.LOADING_END,
    label: 'MDM_LOADING_END_TIME',
    data_type: dataTypes.DATE,
    shipper_only: true,
    validation: 'isLoadingAtSourceEnabled',
  },
  {
    field: editableFields.DISPATCHED,
    label: 'INDENT_TRUCK_OUT_DATE_TIME',
    data_type: dataTypes.DATE,
    shipper_only: false,
  },
];


export const notDeliveredReasons = ['LAST_MILE_CUSTOMER_NA', 'LAST_MILE_CUSTOMER_NOT_REACHABLE', 'LAST_MILE_OTHER_REASON'];

export const lastMileEvents = {
  TRUCKIN: 1,
  START_LOAD: 2,
  TRUCKOUT: 3,
  END_LOAD: 4,
  MARK_DELIVERED: 5,
  NOT_DELIVERED: 6,
};
